import './less/boxAlert.less';

const BoxAlert = props => {
	$(document).find(".JS_box-alert").each(function(i, item){
		let $item = $(item);
		
		if($item.hasClass('autoclose') && $item.data('timeout')) {
			setTimeout(function(){
				$item.slideUp(function(){
					$(this).remove();
				});
			}, $item.data('timeout'));
		}
	});
	
	$(document).on("click", ".JS_box-alert-close", e => {
		let container = $(e.currentTarget).closest(".JS_box-alert").slideUp(function(){
			container.remove();
		});
	});
};

export default BoxAlert();


// WEBPACK FOOTER //
// ./components/UI/boxAlert/boxAlert.js